import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import ClearIcon from "@mui/icons-material/Clear";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const DeleteMemberDialog = ({ id, memberId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(specialistRequests.deleteExamCommitteeMember(id, memberId), null, "DELETE");
    notify("Успешно премахване на член на изпитната комисия", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent={"Премахни член от изпитна комисия"}
      onConfirm={handleSubmit}
      message="Сигурни ли сте, че искате да премахнете член на изпитната комисия?"
      triggerButton={
        <Button
          label="Премахни"
          startIcon={<ClearIcon />}
          variant="contained"
          color="error"
        />
      }
    />
  );
};

export default DeleteMemberDialog;
